import Bugsnag from "@bugsnag/js";
import { refreshToken } from "../api/auth";
import store from "../store";

const handleError = (error: any, defaultMessage?: string) => {
  const { response } = error;
  const { data } = response;
  let returnMessage;
  Bugsnag.notify(error);
  const { message, status, errors } = data;
  if (data && status === "authorization_failed") {
    if (store.getState().auth.user) {
      refreshToken();
    }
  } else if (data && status === "declined") {
    returnMessage = message;
  } else {
    returnMessage = defaultMessage! || message || "Error processing request";
  }

  return {
    status: false,
    data: null,
    message: returnMessage,
    errors: errors,
  };
};

export default handleError;
